<template>
  <GestionExclusionesAdmin />
</template>
<script>
import GestionExclusionesAdmin from "./components/GestionExclusionesAdmin";
export default {
  components: { GestionExclusionesAdmin },
};
</script>